import {i18n} from '@online-offer/i18n';
import {Show, Text} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {SectionPrint} from '../../components/SectionPrint/SectionPrint';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';

export function AdvertisementDescriptionPrint() {
  const {advertisementDescription} = useGetOnlineOfferData();

  return (
    <Show when={isNotNilOrEmpty(advertisementDescription)}>
      <SectionPrint heading={i18n.t('details.sellerDescription')}>
        <Text size="small">{advertisementDescription}</Text>
      </SectionPrint>
    </Show>
  );
}
